import shellHttpClient from '@/shells/api/shellHttpClient';
import { normalizeUpcomingIposResponse } from '@/features/upcoming-ipos/adapters/upcomingIposMapper';

const FALLBACK_ERROR = 'No se pudieron recuperar las IPOs.';

export class UpcomingIposRequestError extends Error {
  constructor(message, status = null) {
    super(message);
    this.name = 'UpcomingIposRequestError';
    this.status = status;
  }
}

export class UpcomingIposRepository {
  constructor(client = shellHttpClient) {
    this.client = client;
  }

  async search({ query = '', country = 'all' } = {}) {
    try {
      const response = await this.client.get('/api/frontend/v1/ipos', {
        params: {
          q: String(query || '').trim(),
          country: String(country || 'all')
        }
      });
      return normalizeUpcomingIposResponse(response.data);
    }
    catch (error) {
      const response = error && error.response;
      const payload = response && response.data;
      const message = payload && payload.error && payload.error.message;
      throw new UpcomingIposRequestError(message || FALLBACK_ERROR, response ? response.status : null);
    }
  }
}

export const upcomingIposRepository = new UpcomingIposRepository();
